import { isPro } from '@core/util/util.isPro';
import { useDirectoryTeam } from '@frontend/shared/hooks/useDirectory';

export function useIsPro() {
  const team = useDirectoryTeam();

  return isPro(team);
}
